import { createAsyncThunk } from "@reduxjs/toolkit";
import { PutVouchersBody } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const putVouchers = createAsyncThunk<void, PutVouchersBody>(
  "vouchers/putVouchers",
  async (body, { rejectWithValue }) => {
    try {
      await VouchersAPI.putVouchers(body);
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while updating vouchers", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      } else {
        console.error("Error while updating vouchers", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
